var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 22 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43431 11.7312L0.234305 6.53123C-0.0781016 6.21883 -0.0781016 5.71229 0.234305 5.39986L1.36565 4.26848C1.67805 3.95604 2.18462 3.95604 2.49702 4.26848L5.99999 7.77142L13.503 0.268484C13.8154 -0.0439218 14.3219 -0.0439218 14.6343 0.268484L15.7657 1.39986C16.0781 1.71227 16.0781 2.2188 15.7657 2.53123L6.56568 11.7313C6.25324 12.0437 5.74671 12.0437 5.43431 11.7312Z",
    fill: "#00AF41"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckMark);
export default __webpack_public_path__ + "static/media/GreenCheckMark.edb5338dce050229cfce10d3947e8c4a.svg";
export { ForwardRef as ReactComponent };